<template>
  <div>
    <template v-if="selectedLead" :headerText="leadHeader | capitalize">
      <div class="actionIconsLead">
        <va-popover
          v-if="showCreateAgendaEvent"
          placement="left"
          :message="$t('leads.agenda.create_event')">
          <va-button large icon="fa fa-calendar-plus-o" color="gray" @click.prevent="createAgendaEvent"></va-button>
        </va-popover>
        <va-popover
          v-if="selectedLead.ht && sendPdfButton"
          placement="left"
          :message="$t('leads.download_lead_report')">
            <va-button large icon="fa fa-download" color="gray" @click.prevent="downloadHearingTestPdf"></va-button>
        </va-popover>
        <va-popover
          v-if="selectedLead.ht && sendPdfButton"
          placement="left"
          :message="$t('leads.notify_lead_report')">
          <va-button large icon="fa fa-envelope" color="gray" @click.prevent="openNotifyEmailModal()"></va-button>
        </va-popover>
        <va-popover
          v-if="isFromEvollu && writePermission && isLeadPromoter"
          placement="left"
          :message="$t('leads.transfer_session.transfer_lead_session')">
          <va-button large icon="fa fa-random" @click.prevent="openLeadTransferModal()"></va-button>
        </va-popover>
        <va-popover
          v-if="isFromEvollu && writePermission"
          placement="left"
          :message="$t('leads.updateEntity')">
          <va-button large icon="fa fa-home" @click.prevent="openLeadUpdateEntityModal()"></va-button>
        </va-popover>
      </div>
      <div class="row">
        <div class="col-md-12"></div>
      </div>
      <div class="row">
        <div class="pb-2" :class="{'col-md-6': locations.length, 'col-md-12': !locations.length}">
          <div v-if="selectedLead.phone"><span class="is-bold">{{ $t('references.inputs.mobile_phone') }}:</span> {{selectedLead.phone}}</div>
          <div v-if="selectedLead.phone_2"><span class="is-bold">{{ $t('leads.details.phone') }}:</span> {{selectedLead.phone_2}} </div>
          <div><span class="is-bold">Email:</span> {{selectedLead.email || 'N.d.'}}</div>
          <div v-if="selectedLead.address_line_1 || selectedLead.address_line_2 || selectedLead.address_city || selectedLead.address_postal_code">
            <span class="is-bold">{{ $t('leads.details.address') }}:</span>
            {{selectedLead.address_line_1}}<span v-if="selectedLead.address_line_1 && (selectedLead.address_line_2 || selectedLead.address_postal_code)">, </span>
            {{selectedLead.address_line_2}}<span v-if="selectedLead.address_line_2 && (selectedLead.address_city || selectedLead.address_postal_code)">, </span>
            {{selectedLead.address_city}}<span v-if="selectedLead.address_city && selectedLead.address_postal_code">, </span>
            {{selectedLead.address_postal_code}}
          </div>
          <div v-if="selectedLead.birthdate">
            <span v-if="isWebLead" class="is-bold">{{ $t('leads.details.age') }}:</span>
            <span v-else class="is-bold">{{ $t('leads.details.birthdate') }}:</span>
            {{ birthdate }}
          </div>
          <div v-if="selectedLead.health_system"><span class="is-bold">{{ $t('leads.details.health_system') }}:</span> {{selectedLead.health_system}} </div>
          <div v-if="selectedLead.contact_request">
            <span class="is-bold">{{ $t('leads.details.contact_request')}}:</span> {{ $t('leads.details.yes')}}
          </div>
          <div><span class="is-bold">{{ $t('leads.details.contact_time') }}:</span> {{contactBestTime[selectedLead.appointment_option]}}</div>
          <div v-if="(selectedLead.contacted_at || selectedLead.status === 11 || selectedLead.status >= 99) && !isEditingCustomerRef"><span class="is-bold">
            {{ $t('leads.details.customer_ref') }}:</span> {{selectedLead.customer_ref}}
            <a v-if="writePermission" href="#" @click.prevent="editCustomerRef()"><i class="fa fa-pencil" style="margin-left: 3px;" aria-hidden="true"></i></a>
          </div>
          <div v-if="isEditingCustomerRef" class="d-flex mt-2">
            <span style="width: calc(100% - 50px);">
              <va-input
                :label="$t('leads.details.customer_ref')"
                v-model="editingCustomerRef"
                :maxlength="250"/>
            </span>
            <span><a href="#" @click.prevent="saveCustomerRef()"><i class="customer-ref-icons fa fa-save" aria-hidden="true"></i></a></span>
            <span><a href="#" @click.prevent="cancelEditCustomerRef()"><i class="customer-ref-icons fa fa-times" aria-hidden="true"></i></a></span>
          </div>
          <br>
          <div v-if="selectedLead.placing"><span class="is-bold">{{ $t('leads.details.placing') }}:</span> {{selectedLead.placing}} </div>
          <div v-if="selectedLead.city"><span class="is-bold">{{$t('leads.details.city')}}:</span> {{selectedLead.city}}</div>
          <div v-if="selectedLead.source_id">
            <span class="is-bold">{{$t('leads.details.source_id')}}:</span> {{$t(`leads.details.source.${selectedLead.source_id}`)}}
          </div>
          <div v-if="selectedLead.session_id"><span class="is-bold">{{ $t('leads.details.promoter') }}:</span>
          {{selectedLead.promoter ? selectedLead.promoter : $t('agenda.undefined_promoter')}}</div>

          <div v-if="selectedLead.comment"><span class="is-bold">{{ $t('leads.details.comment') }}:</span>
            {{selectedLead.comment}}</div>
          <br>
          <div v-if="selectedLead.privacy_policy">
            <span class="clickable" @click.prevent="$emit('openPrivacyPolicyModal', {})">
              <span class="clickable is-bold">{{ $t('leads.details.privacy_policy') }} </span>
              <i class="px-1 fa fa-external-link"></i>
            </span>
          </div>

          <div v-if="selectedLead.gender !== null">
            <span class="is-bold">{{ $t('acconts.gender')}}:</span> {{ selectedLead.gender !== "n/a" ? $t(`genders.${selectedLead.gender}`) : "N/A"}}
          </div>
        </div>

        <div class="col-md-6 mt-3 pb-2" style="align-self: flex-end;" v-if="locations.length">
          <google-map style="box-shadow: 0px 5px 9px 0px #e8e8e8; height: 160px; width: 280px;" :zoom="10" :fitBounds="false" :locations="locations" :center="locations[0].position"></google-map>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12" v-if="selectedLead.obs"><span class="is-bold">{{$t('leads.details.observations')}}:</span> {{selectedLead.obs}}</div>
      </div>
    </template>

    <va-modal
      v-model="showNotifyEmailModal"
      ref="notifyEmailModal"
      :cancelText="$t('modal.cancel')"
      :okText="$t('auth.send')"
      @ok="notifyEmail"
      @cancel="closeNotifyEmail"
      :okDisabled="!emails.length || invalidEmail"
      :fixedLayout="true">

      <div slot="header">
        <b style="font-size:22px; margin-bottom: 1rem;">{{ $t('leads.notify_modal_title') }}</b>
      </div>

      <div class="form-group">
        <div class="input-group">
          <va-input
            :label="$t('leads.message')+' ('+$t('references.inputs.optional')+')'"
            type="textarea"
            id="simple-textarea"
            v-model="editingMessage"
            required/>
        </div>
      </div>

      <ul class="vue-unordered"><h6 v-if="emails.length > 0">{{ $t('leads.recipients') }}:</h6>
        <li v-for="(email, index) in emails" :key="index">
          {{ email }} &nbsp;
          <i class="email-notification-icon fa fa-times" @click="emails.splice(index, 1)"></i>
        </li>
      </ul>
      <div class="form-group with-icon-right" style="margin-bottom:1.5rem;" :class="{'has-error': invalidEmail && editingEmail !== '', 'valid': !invalidEmail && editingEmail !== ''}">
        <div class="input-group">
          <va-input
            id="successfulEmail"
            name="successfulEmail"
            v-model="editingEmail"
            @keyup.enter="addEmail"
            label="Email"
            :success="editingEmail !== '' && !invalidEmail"
            :error="invalidEmail"
            :error-messages="[$t('users.inputs.invalid_email')]"
          />
        </div>
      </div>
      <div>
        <small class="text-muted">{{ $t('leads.notify_modal_message') }}</small>
      </div>
    </va-modal>
  </div>
</template>

<script>
import { EMAIL_REGEX } from '@/utils/regex'
import { TemplateService } from '@/api/LeadsService'
import LeadSessionTransfer from './LeadSessionTransfer'
import CurrentLocaleMixin from '@/mixins/CurrentLocaleMixin'
import GoogleMap from '@/components/maps/google-maps/GoogleMap.vue'
import IsFromEvolluMixin from '@/mixins/IsFromEvolluMixin'

export default {
  props: {
    showCreateAgendaEvent: {
      type: Boolean,
      required: true,
      default: false
    },
    selectedLead: {
      type: Object,
      required: true
    },
    entitiesWrite: {
      type: Array,
      required: true
    }
  },
  components: {
    GoogleMap,
    LeadSessionTransfer
  },
  mixins: [
    CurrentLocaleMixin,
    IsFromEvolluMixin
  ],
  data () {
    return {
      transferTooltipConfig: {
        content: this.$t('leads.transfer_session.transfer_lead_session'),
        placement: 'left'
      },
      availableTemplateEntitiesIds: [],
      contactBestTime: [
        this.$t('references.contactBestTime.n_d'),
        this.$t('references.contactBestTime.early_morning'),
        this.$t('references.contactBestTime.late_morning'),
        this.$t('references.contactBestTime.early_afternoon'),
        this.$t('references.contactBestTime.late_afternoon'),
        this.$t('references.contactBestTime.no_contact')
      ],
      showNotifyEmailModal: false,
      isEditingCustomerRef: false,
      editingCustomerRef: '',
      editingMessage: '',
      editingEmail: '',
      emails: [],
    }
  },
  created () {
    this.loadAvailableTemplates()
  },
  methods: {
    createAgendaEvent: function() {
      this.$emit('openAgendaEventForm')
    },
    downloadHearingTestPdf: function () {
      this.$http({
        url: `${this.$store.state.evollead_server}/leads/${this.selectedLead.id}/download`,
        method: 'GET',
        responseType: 'blob',
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${this.$t('leads.lead_report_name')}_${this.selectedLead.name.replace(' /g', '').toLowerCase()}.pdf`)
          document.body.appendChild(link)
          link.click()
        })
        .catch(errors => this.showToast(this.$t('reports.templates.messages.something_went_wrong'), this.$store.state.errorToastOptions))
    },
    loadAvailableTemplates: function () {
      TemplateService.query()
        .then(availableTemplates => {
          this.availableTemplateEntitiesIds = availableTemplates
        }).catch(error => {
          console.log(error)
        })
    },
    editCustomerRef: function () {
      this.editingCustomerRef = this.selectedLead.customer_ref
      this.isEditingCustomerRef = true
    },
    cancelEditCustomerRef: function () {
      this.isEditingCustomerRef = false
      this.editingCustomerRef = ''
    },
    saveCustomerRef: function () {
      this.$http({
        url: this.$store.state.evollead_server + '/leads/' + this.selectedLead.id,
        method: 'PATCH',
        data: { customer_ref: this.editingCustomerRef }
      }).then((response) => {
        this.selectedLead.customer_ref = this.editingCustomerRef
        this.isEditingCustomerRef = false
        this.editingCustomerRef = ''
        this.showToast(this.$t('leads.notification_success'), this.$store.state.successToastOptions)
      }).catch((error) => {
        console.log(error.response)
        let err = Object.keys(error.response.data)[0]
        this.showToast(this.$t('leads.messages.' + err), this.$store.state.errorToastOptions)
      })
    },
    openLeadTransferModal: function () {
      this.$emit('openLeadTransferModal')
    },
    openLeadUpdateEntityModal: function () {
      this.$emit('openLeadUpdateEntityModal')
    },
    closeNotifyEmail: function () {
      this.emails = []
      this.editingEmail = ''
    },
    addEmail: function () {
      if (this.invalidEmail || this.editingEmail === '') return
      this.emails.push(this.editingEmail.toLowerCase())
      this.editingEmail = ''
    },
    notifyEmail: function () {
      if (this.editingEmail !== '' && !this.invalidEmail) {
        this.emails.push(this.editingEmail.toLowerCase())
        this.editingEmail = ''
      }
      this.$http({
        url: this.$store.state.evollead_server + '/leads/' + this.selectedLead.id + '/notify',
        method: 'POST',
        data: { emails: this.emails, message: this.editingMessage, lang: this.locale }
      }).then((response) => {
        this.emails = []
        this.editingEmail = ''
        this.editingMessage = ''
        this.showToast(this.$t('leads.notification_success'), this.$store.state.successToastOptions)
      }).catch((error) => {
        console.log(error.response)
        let err = Object.keys(error.response.data)[0]
        this.showToast(this.$t('leads.messages.' + err), this.$store.state.errorToastOptions)
      })
    },
    openNotifyEmailModal: function () {
      this.$nextTick(() => {
        this.showNotifyEmailModal = true
      })
    },
  },
  computed: {
    writePermission: function () {
      return this.entitiesWrite.includes(this.selectedLead.entity_id)
    },
    isLeadPromoter: function () {
      return this.selectedLead.source_id === 4 && this.user_id !== null
    },
    isWebLead: function () {
      return this.selectedLead.source_id && (this.selectedLead.source_id === 3 || this.selectedLead.source_id === 5 || this.selectedLead.source_id === 7)
    },
    birthdate: function () {
      if (this.isWebLead) {
        let created = this.moment(this.selectedLead.created_at, 'YYYY-MM-DD')
        let date = this.moment(this.selectedLead.birthdate, 'DD/MM/YYYY')
        let total = created.diff(date, 'years', true)
        let val = total < 18 ? '< 18' : total <= 29 ? '18 - 29' : total <= 49 ? '30 - 49' : total < 65 ? '50 - 65' : '> 65'
        return val
      }
      return this.selectedLead.birthdate
    },
    invalidEmail: function () {
      if (this.editingEmail) {
        return !this.editingEmail.match(EMAIL_REGEX)
      }
      return false
    },
    leadHeader: function () {
      let header = ''
      if (this.selectedLead && this.selectedLead.title && this.selectedLead.name && this.selectedLead.surname) {
        header = this.selectedLead.title + ' ' + this.selectedLead.name + ' ' + this.selectedLead.surname
      } else if (this.selectedLead && this.selectedLead.name && this.selectedLead.surname) {
        header = this.selectedLead.name + ' ' + this.selectedLead.surname
      } else if (this.selectedLead && this.selectedLead.name) {
        header = this.selectedLead.name
      }
      return header
    },
    sendPdfButton: function () {
      return Array.isArray(this.availableTemplateEntitiesIds) && this.availableTemplateEntitiesIds.some(entityId => this.selectedLead.entity_id === entityId || this.selectedLead.aud_provider_id === entityId)
    },
    locations: function () {
      let locations = []
      if (this.selectedLead.lat && this.selectedLead.lng) {
        let id = this.selectedLead.id
        let lat = this.selectedLead.lat
        let lng = this.selectedLead.lng
        let location = { id, position: { lat, lng } }
        locations.push(location)
      }
      return locations
    }
  }
}
</script>

<style lang="scss">

.actionIconsLead {
  display:flex;
  flex-direction: row;
  position:absolute;
  right: 1.5rem;
  top: 2.75rem;
  z-index: 2;
  button {
    background-color: $evollu-gray-light !important;
    background-image: none !important;
  }
  i.va-button__content__icon {
    width: 1.25rem;
  }
}

</style>

<style scoped lang="scss">
.customer-ref-icons {
    cursor: pointer;
    color: #29c4a9;
    font-size: 120%;
    margin-top: 10px;
    margin-left: 8px;
}

.addPatientIcon{
  margin-bottom: 10px;
}

.email-notification-icon {
  color: red;
  font-size: 0.9rem;
  cursor: pointer;
}

li::before{
  width:0.5rem !important;
  height: 0.5rem !important;
}

</style>
